import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDown,
  faAngleUp,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

import classNames from 'classnames';
import styles from './index.module.scss';

const DropDown = ({ value, handleChange, options, children, label, price }) => {
  const [expanded, setExpanded] = useState(false);

  const expand = () => {
    setExpanded(true);
  };

  const close = () => {
    setExpanded(false);
    if (children && (price?.[0]?.length || price?.[1]?.length)) {
      // Apply blur on clicking/closing the dropbox again.
      children?.props?.children[0]?.props?.children?.props?.onBlur(price?.[0]);
      children?.props?.children[2]?.props?.children?.props?.onBlur(price?.[1]);
    }
  };

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      close();
    }
  };

  const handleResetFilterValue = useCallback(
    (e) => {
      e.stopPropagation();
      if (children) {
        // [input,span,input]
        children?.props?.children[0].props.children.props.onChange(() => '');
        children?.props?.children[2].props.children.props.onChange(() => '');
      }
      handleChange('');
    },
    [children, handleChange],
  );

  const renderIcons = useCallback(
    (hide) => {
      if (
        (value.length || price?.[0]?.length || price?.[1]?.length) &&
        !expanded &&
        !hide
      ) {
        return (
          <FontAwesomeIcon
            onMouseDown={handleResetFilterValue}
            icon={faTimesCircle}
            style={{ zIndex: '3', width: '13.55px', height: '13.55px' }}
          />
        );
      }
      if (
        (!value.length || !price?.[0]?.length || !price?.[1]?.length) &&
        expanded
      ) {
        return (
          <FontAwesomeIcon
            icon={faAngleUp}
            style={{ width: '8.75px', height: '14px' }}
          />
        );
      }
      return (
        <FontAwesomeIcon
          icon={faAngleDown}
          style={{ width: '8.75px', height: '14px' }}
        />
      );
    },
    [value.length, price, expanded, handleResetFilterValue],
  );

  if (Object.values(children).length) {
    // Price-dropdown
    return (
      <div onBlur={handleBlur} className={styles.dropdownBox}>
        <button
          type="button"
          onMouseDown={expanded ? close : expand}
          onKeyDown={(e) => {
            if (e.key === 'Escape' && expanded) return close();
            return expand;
          }}
          data-cy="dropdown-button1"
        >
          {price?.[0]?.length || price?.[1]?.length ? (
            <>
              <span>{price?.[0]?.length ? `${price?.[0]}€` : 'min'}</span>
              <span>-</span>
              <span>{price?.[1]?.length ? `${price?.[1]}€` : 'max'}</span>
            </>
          ) : (
            'Preis'
          )}
          {renderIcons()}
        </button>
        <div className={classNames({ [styles.show]: expanded })}>
          {expanded && children}
        </div>
      </div>
    );
  }
  // Rooms, sorting, zustand - dropdown
  return (
    <div onBlur={close} className={styles.dropdownBox}>
      <button
        type="button"
        onMouseDown={expanded ? close : expand}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && expanded) return close();
          return expand;
        }}
        data-cy="dropdown-button2"
      >
        {value?.length ? value : label}
        {!value.includes('absteigend') && !value.includes('aufsteigend')
          ? renderIcons()
          : renderIcons('hide')}
      </button>
      {expanded && (
        <div className={classNames({ [styles.show]: expanded })}>
          {options?.map((item) => (
            <span
              role="presentation"
              data-cy="items-show"
              key={item.text}
              onMouseDown={() => {
                handleChange(item);
                close();
              }}
            >
              {item.text}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

DropDown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  options: PropTypes.array,
  children: PropTypes.object,
  price: PropTypes.array,
};
DropDown.defaultProps = {
  label: '',
  value: '',
  options: [],
  children: {},
  handleChange: () => '',
  price: [],
};
export default DropDown;
